import { Injectable } from '@angular/core';
import { CONFIGSUMADI } from '../../constants/constants';
import { ltiLaunchDB, userTipeLTI } from '../../model/lti-launch';
import { TokenControlService } from '../state/tokenControl.service';
import { WelcomeService } from '../welcome/welcome.service';

@Injectable({
  providedIn: 'root'
})
export class LtiService {

  public idSessionStart: number;

  public sumadiData: any;

  private LtiSumadiE: ltiLaunchDB = {
    name: CONFIGSUMADI.NAME,
    url: CONFIGSUMADI.URL,//'https://dev-plexi.sumadi.net/lti/v1',  //'https://icfes-test.sumadi.net/lti/v1',
    consumerKey: CONFIGSUMADI.KEY,
    consumerSecret: CONFIGSUMADI.SECRET,
    params: [
      { name: 'lti_version', value: 'LTI-1p0', isConstant: true },
      { name: 'tool_consumer_info_product_family_code', value: 'Plexi', isConstant: true },
      { name: 'lis_person_sourcedid', value: '', isConstant: false, link: "fullName" },
      { name: 'lis_person_name_given', value: '', isConstant: false, link: "fullName" },
      { name: 'lis_person_name_family', value: '', isConstant: true },
      { name: 'lis_person_name_full', value: '', isConstant: false, link: "fullName" },
      { name: 'resource_link_id', value: 'resource_link_id_test', isConstant: true },
      { name: 'custom_user_locale', value: 'es_ES', isConstant: true },
      { name: 'custom_user_role', value: 'S', isConstant: true },
      { name: 'user_id', value: '', isConstant: false, link: "tokenId" },
      { name: 'custom_course_id', value: '', isConstant: false, link: "idCurso" },
      { name: 'custom_course_name', value: '', isConstant: false, link: "test" },
      { name: 'custom_course_role', value: 'S', isConstant: true },
      { name: 'custom_course_locale', value: 'es_ES', isConstant: true },
      { name: 'custom_account_id', value: CONFIGSUMADI.ACCOUNT_ID, isConstant: true },
      { name: 'lti_message_type', value: 'basic-lti-launch-request', isConstant: true },
      { name: 'custom_assessment_id', value: '', isConstant: false, link: "session" },
      { name: 'launch_presentation_return_url', value: '', isConstant: false, link: "returnUrl" },
      { name: 'custom_exam_type', value: 'placement_test', isConstant: true },
      { name: 'custom_lis_user_codes', value: '', isConstant: false, link: "identificacion" },
      { name: 'custom_student_credential', value: '', isConstant: false, link: "credentialId" }
    ]
  }

  private LtiSumadiS: ltiLaunchDB = {
    name: CONFIGSUMADI.NAME,
    url: CONFIGSUMADI.URL, //'https://icfes-test.sumadi.net/lti/v1',
    consumerKey: CONFIGSUMADI.KEY,
    consumerSecret: CONFIGSUMADI.SECRET,
    params: [
      { name: 'lti_version', value: 'LTI-1p0', isConstant: true },
      { name: 'tool_consumer_info_product_family_code', value: 'Plexi', isConstant: true },
      { name: 'lis_person_sourcedid', value: '', isConstant: false, link: "fullName" },
      { name: 'lis_person_name_given', value: '', isConstant: false, link: "fullName" },
      { name: 'lis_person_name_family', value: '', isConstant: true },
      { name: 'lis_person_name_full', value: '', isConstant: false, link: "fullName" },
      { name: 'resource_link_id', value: 'resource_link_id_test', isConstant: true },
      { name: 'custom_user_locale', value: 'es_ES', isConstant: true },
      { name: 'custom_user_role', value: 'I', isConstant: true },
      { name: 'user_id', value: '', isConstant: false, link: "tokenId" },
      { name: 'custom_course_id', value: '', isConstant: false, link: "credentialId" },
      { name: 'custom_course_name', value: '', isConstant: false, link: "test" },
      { name: 'custom_course_role', value: 'I', isConstant: true },
      { name: 'custom_course_locale', value: 'es_ES', isConstant: true },
      { name: 'custom_account_id', value: CONFIGSUMADI.ACCOUNT_ID, isConstant: true },
      { name: 'custom_redirect_url', value: CONFIGSUMADI.REDIRECT_URL, isConstant: true },
      { name: 'lti_message_type', value: 'basic-lti-launch-request', isConstant: true },
      { name: 'custom_exam_type', value: 'placement_test', isConstant: true }
    ]
  }

  constructor(private _tokenController: TokenControlService, private _welcomeDataService: WelcomeService,) {
  }

  getConfiguration(userTipe: userTipeLTI, idConfiguration: Number): ltiLaunchDB {
    return userTipe == userTipeLTI.ESTUDENT ? this.getLaunchConfigurationStudent(idConfiguration) : this.getLaunchConfigurationSupervisor(idConfiguration);
  }


  /**TODO:
   * bring those data from backend
   */

  getLaunchConfigurationStudent = (codeConfiguration: Number): ltiLaunchDB => this.LtiSumadiE;

  getLaunchConfigurationSupervisor = (codeConfiguration: Number): ltiLaunchDB => this.LtiSumadiS;

}
